import angular from 'angular';
import Logger from '../../../shared/logger';

export const PublicCandidateProfileService = (Restangular) => {
    const getProfile = (talentId, workflowId, workflowDate, profileForSubmission) =>
        Restangular
            .all('public')
            .all('candidate')
            .customPOST({ talentId, workflowId, workflowDate, profileForSubmission })
            .catch(error => Logger.error(error));

    return {
        getProfile,
    };
};

angular.module('TALENYA-FE')
    .factory('PublicCandidateProfileService', PublicCandidateProfileService);